import React from 'react';
// import images from ""
function Notification() {
  return (
    <div className="w-[1170px] h-[1316px]  mx-auto rounded-xl mt-[40px] flex flex-col gap-[30px] mb-5">
      <div
        className="w-full h-[377px] bg-[#ffffff] px-[48px] py-[18px]  flex flex-col justify-between rounded-xl  "
        style={{
          boxShadow: ' 0px 4px 4px rgba(0, 0, 0, 0.12)',
        }}
      >
        <div>
          <h1 className="font-medium text-2xl font-sfPro text-[#000000]">Today</h1>
        </div>

        <div className="w-full h-[288px]   flex flex-col justify-between">

          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>

          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
        </div>

      </div>
      <div
        className="w-full h-[909px] bg-[#ffffff] px-[48px] py-[18px]  flex flex-col justify-between rounded-xl gap-[28px] "
        style={{
          boxShadow: ' 0px 4px 4px rgba(0, 0, 0, 0.12)',
        }}
      >
        <div>
          <h1 className="font-medium text-2xl font-sfPro text-[#000000]">Earlier</h1>
        </div>

        <div className="w-full h-full   flex flex-col justify-between ">

          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>

          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>

          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
          <div className="w-full h-[60px]   flex items-center gap-[21px]  ">
            <div className="w-[60px] h-[60px] rounded-[50%]  items-center overflow-hidden"><img src="images/arriving-white-truck-road-rural-landscape-sunset_93200-1619.png" alt="imges" className="object-cover h-full w-full" /></div>
            <div className=" w-full h-full flex justify-between ">
              <div className="h-full flex flex-col justify-between">
                <h1 className="font-400 text-[22px] text-[#000000] font-sfPro"> Andri Delgado</h1>
                <p className=" font-normal text-base text-black text-opacity-[0.4] font-sfPro">Quae ullam error voluptatem, quae suntd.Reiciendis cupiditate asperiores nullax.</p>
              </div>
              <p className="font-normal text-sm text-black text-opacity-[0.6]"> 02:43 PM</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Notification;
